<script>
export default {
  name: "DidoMillesimeTableRowBasicFilters",
};
</script>

<script setup>
import { computed, ref, watch } from "vue";
import DidoMillesimeInputFilterWrapper from "../../filters/Wrapper.vue";

// define Props
const props = defineProps({
  show: { type: Boolean, required: true },
  apiUrl: { type: String, required: true },
  visibleColumns: { type: Array, required: true },
  availableFiltersInColumns: { type: Array, required: true },
  modelValue: { type: Object, required: true },
});

// define Emits
const emit = defineEmits(["update:model-value"]);

// define reactive data and watcher from props for activeFilters
const activeFilters = ref(props.modelValue);
watch(
  () => props.modelValue,
  () => (activeFilters.value = props.modelValue),
);
// define computed datas
const activeBasicFiltersInColumns = computed(() => {
  const o = {};
  Object.keys(activeFilters.value).forEach((colName) => {
    const { filters, availableValues } = specsOfColumn(colName);
    if (availableValues && availableValues.length)
      o[colName] = {
        type: "in",
        value: activeFilters.value[colName].value,
      };
    else if (filters.find((filterName) => filterName === "contains"))
      o[colName] = {
        type: "contains",
        value: activeFilters.value[colName].value,
      };
    else o[colName] = { type: "", value: "" };
  });
  return o;
});

// define method for specs of column
const specsOfColumn = (colName) =>
  props.availableFiltersInColumns.find(({ name }) => name === colName);

// define method for type of columns
const typeOfColumn = (colName) => specsOfColumn(colName).type;

const availableValuesOfColumn = (colName) => {
  // get available values in column specs
  const { availableValues } = specsOfColumn(colName);

  return availableValues && availableValues.length ? availableValues : null;
};
</script>

<template>
  <QTr v-if="props.show">
    <QTd
      v-for="colName in props.visibleColumns"
      :key="colName"
      class="bg-grey-2 text-secondary"
    >
      <DidoMillesimeInputFilterWrapper
        v-if="activeBasicFiltersInColumns[colName]?.type"
        v-model="activeBasicFiltersInColumns[colName].value"
        :filter="activeBasicFiltersInColumns[colName].type"
        :available-values="availableValuesOfColumn(colName)"
        :type="typeOfColumn(colName)"
        :api-url="props.apiUrl"
        @update:model-value="[
          (activeFilters[colName] = {
            type: activeBasicFiltersInColumns[colName].type,
            value: $event,
          }),
          emit('update:model-value', activeFilters),
        ]"
      />
    </QTd>
  </QTr>
</template>
